import { useMutation } from '@tanstack/react-query';
import * as Api from '@ViewModels';
import { useUserSession } from '../../models/hooks/appStateHooks';

export interface IContactUnarchiveMutationArgs {
	excludeContactIds?: string[];
	filter?: Api.IContactsFilterRequest;
	ownershipFilter?: Api.IOwnershipFilter;
	includeContactIds?: string[];
}

export function useContactUnarchiveMutation({
	onSuccess,
	onError,
}: {
	onSuccess?: (data: number) => void;
	onError?: (error: Api.IOperationResultNoValue) => void;
} = {}) {
	const userSession = useUserSession();

	return useMutation({
		mutationFn: (request: IContactUnarchiveMutationArgs) => {
			return userSession.webServiceHelper.callAsync<number>(
				Api.ImpersonationBroker.composeApiUrl({
					urlPath: 'contact/unarchive',
				}),
				'POST',
				request
			);
		},
		onSuccess,
		onError,
	});
}
